import React from "react";

export default function CheckoutItem({ image, name, cast, price, author,interval }) {
  const secondText = interval ==="month"?"Monthly":"Yearly";
  return (
    <div className="w-full flex items-center bg-[#384355] border border-borderGray p-3 px-4 rounded-md">
      {/* <div className="overflow-hidden rounded-lg w-[4.5rem] h-[4.5rem] md:w-[6rem] md:h-[6rem] bg-gray-50 border border-gray-200">
        <img
          src={image}
          alt=""
          className="object-cover object-center w-[4.5rem] h-[4.5rem] md:w-[6rem] md:h-[6rem]"
        />
      </div> */}
      <div className="flex-grow ">
        <h6 className="font-semibold text-sm md:text-lg md:mr-8 mr-4 text-white">
          {name}
        </h6>
        <p className="text-gray-300 text-sm md:text-base font-normal mt-1">
          {secondText}
        </p>
      </div>
      <div>
        <span className="font-semibold text-white text-base md:text-lg">
          ${price}
        </span>
        <span className="font-semibold text-white text-sm">.00</span>
      </div>
    </div>
  );
}
